module.exports = __webpack_public_path__ + "static/img/role-de.981f626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-1/role-de.png
// module id = qnHH
// module chunks = 1